export default __webpack_public_path__ + "static/media/IMG_5128.3e3778da.JPG";